import React, { Component } from 'react';
import { connect } from 'react-redux';
import {rankSelector} from "../redux/selectors";
import { toArray } from "../common/util";


class Ranks extends Component {
    componentDidMount() {
        document.title = "Addiction | Ranks"
    }
    render() {

        const rankSummary = toArray(this.props.ranks)
            .sort((a, b) => (b.order - a.order))
            .map((item) => (
                <div key={`${item.id}-rank`} className="panel-adt clearfix">
                    <div className="roster-division-color" style={{
                        height: "100%",
                        width: "5px",
                        backgroundColor: `#${item.color}`,
                        boxShadow: `0 0 40px 1px #${item.color}`,
                        }}
                    />
                    <img className="pull-left" alt={item.title} src={item.image} />
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                </div>

        ));
        return (
            <div>
                <h1>Ranks</h1>
                {rankSummary}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    ranks: rankSelector(state),
});

export default connect(mapStateToProps)(Ranks);


// WEBPACK FOOTER //
// ./src/About/Ranks.js